import {getLangCode} from '../App/selectors';

export const connectLanguage = (component, connect) =>
  connect(
    state => ({
      language: getLangCode(state),
    }),
    null
  )(component);
